import Vue from 'vue'
import Router from 'vue-router'
import FAQ from '@/components/FAQ.vue'
import Main from '@/components/Main.vue'
import Impressum from '@/components/Impressum.vue'
import Downloads from '@/components/Downloads.vue'
import Contact from '@/components/Contact.vue'
import Datenschutz from '@/components/Datenschutz.vue'
import Dashboard from '@/components/Dashboard.vue'

import store from '@/store'
// import App from '@/App'
import { languages } from '@/i18n'
import i18n from '@/i18n'

Vue.use(Router)


const routes = [
  {
    path: '*', 
    beforeEnter(to, from, next) {
      next(store.state.locale)
    }
  },
  {
    path: '/:lang',
    component: {
      render(c) { return c('router-view')}
    },
    beforeEnter(to, from, next) {
      let lang = to.params.lang
      if (languages.includes(lang)) {
        store.dispatch('changeLocale', lang)
        return next()
      }
      return next({ path: store.state.locale + '/' + to.params.lang })
    },
    children: [
      {
        path: '',
        component: Main,
        meta: {
          title: 'router_main_title',
          description: 'router_main_description'
        },
      },
      {
        path: 'faq',
        component: FAQ,
        meta: {
          title: 'router_faq_title',
          description: 'router_faq_description'
        }
      },
      {
        path: 'downloads',
        component: Downloads,
        meta: {
          title: 'router_downloads_title',
          description: 'router_downloads_description'
        }
      },
      {
        path: 'contact',
        component: Contact,
        meta: {
          title: 'router_contact_title',
          description: 'router_contact_description'
        }
      },
      {
        path: 'imprint',
        component: Impressum,
        meta: {
          title: 'router_impressum_title',
          description: 'router_impressum_description'
        }
      },
      {
        path: 'dataprotection',
        component: Datenschutz,
        meta: {
          title: 'router_datenschutz_title',
          description: 'router_datenschutz_description'
        }
      },
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'dashboard',
        meta: {
          title: 'router_dashboard_title',
          description: 'router_dashboard_description'
        }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes
})

router.afterEach((to) => {
    document.documentElement.lang = i18n.locale;
    document.title = i18n.t(to.meta.title) + ' | INWT Statistics' || 'Bundestagswahl 2021: Unsere Prognose | INWT Statistics',
    document.querySelector('meta[name="description"]').setAttribute("content", i18n.t(to.meta.description));
})

export default router;
